import React from "react";

// Mot-symbole PROGÈRE universel, identique au reste du site (logo/landing) :
// PRO (or) + GÈRE (rouge) + suffixe module (blanc / noir en clair). Police du site.
export function ProgereBrand({ module = "CORE", size = "medium", className = "" }) {
  const sizeCls =
    size === "large" ? "progere-brand-metal--large" :
    size === "small" ? "progere-brand-metal--small" : "progere-brand-metal--medium";
  return (
    <span className={`progere-brand-metal ${sizeCls} ${className}`}>
      <span className="pg-pro">PRO</span>
      <span className="pg-gere">GÈRE</span>
      {module && <span className="progere-brand-module" style={{ marginLeft: 6 }}>{module}</span>}
    </span>
  );
}
